<mat-form-field [appearance]="appearance">
    <mat-label>{{label}}</mat-label>
    <input 
    matInput 
    [ngModel]="value" 
    (ngModelChange)="changed.emit($event)" 
    [placeholder]="placeholder"
    [disabled]="disabled">
</mat-form-field>
